module.exports = __webpack_public_path__ + "img/report.05796c15.svg";